<template lang="html">
  <div class="full-page">
    <i-header title="投资者基本信息" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body>
      <cube-form
        class="form-custom"
        :model="Model"
        :options="options"
        @submit="$_handlerSubmit">
        <cube-form-group legend="管理人信息">
          <cube-form-item :field="Fields[0]"></cube-form-item>
          <cube-form-item :field="Fields[1]">
            <div @click.stop="$_handleShowOrgTypePicker" style="text-align:right;">
              <span
                :style="{'color': Model.orgType ? '#666' : '#ccc'}">
                {{Model.orgType || '请选择机构类型'}}
              </span>
              <i class="cubeic-arrow"></i>
            </div>
          </cube-form-item>
          <cube-form-item :field="Fields[2]"></cube-form-item>
          <cube-form-item :field="Fields[3]"></cube-form-item>
          <cube-form-item :field="Fields[4]">
            <div @click.stop="$_handleShowOrgDocumentsValidityPicker" style="text-align:right;">
              <span
                :style="{'color': Model.orgValidity ? '#666' : '#ccc'}">
                {{Model.orgValidity || '请选择证件有效期'}}
              </span>
              <i class="cubeic-arrow"></i>
            </div>
          </cube-form-item>
          <cube-form-item :field="Fields[5]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="">
          <cube-form-item :field="Fields[6]"></cube-form-item>
          <cube-form-item :field="Fields[7]"></cube-form-item>
          <cube-form-item :field="Fields[8]"></cube-form-item>
          <cube-form-item :field="Fields[9]">
            <div @click.stop="$_handleShowOrgBusinessScopePicker" style="text-align:right;">
              <span
                :style="{'color': Model.orgBusinessScope ? '#666' : '#ccc'}">
                {{Model.orgBusinessScope || '请选择机构经营范围'}}
              </span>
              <i class="cubeic-arrow"></i>
            </div>
          </cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" >
          <cube-form-item :field="Fields[10]"></cube-form-item>
          <cube-form-item :field="Fields[11]"></cube-form-item>
          <cube-form-item :field="Fields[12]"></cube-form-item>
        </cube-form-group>

        <cube-form-group legend="" class="submit-btn">
          <cube-button type="submit">下一步</cube-button>
        </cube-form-group>
      </cube-form>
    </i-body>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getInvestorProductInfo } from '@/api/investor';
import mixin from './config/viewManagerConfig';

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters(['managerInfo', 'au', 'productInfo']),
  },
  mounted() {
    this.$_handlerInit();
  },
  methods: {
    $_handlerInit() {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      getInvestorProductInfo({
        productDealId: this.managerInfo.productDealId,
      }, this.au).then((res) => {
        toast.hide();
        if (res.code === 0) {
          Object.keys(this.Model).forEach((key) => {
            this.Model[key] = res.data.bean[key];
          });
          this.$store.dispatch('changeProductInfo', this.Model);
        } else {
          this.$createToast({
            txt: res.msg,
            type: 'txt',
            mask: true,
            time: 2000,
          }).show();
        }
      });
    },
    $_handlerSubmit(e) {
      e.preventDefault();
      this.$_handleSaveInfo();
    },
    $_handleSaveInfo() {
      const toast = this.$createToast({
        txt: '加载中...',
        type: 'loading',
        mask: true,
        time: 0,
      }).show();
      setTimeout(() => {
        this.$store.dispatch('changeProductInfo', this.Model).then(() => {
          toast.hide();
          this.$router.push({
            path: '/product/questions',
            query: {
              type: this.$route.query.type,
            },
          });
        });
      }, 1000);
    },
  },
};
</script>
